export const locale = {
    lang: 'en',
    data: {
        PROJECTS_BOARD_NEW_DIALOG_CREATE_BOARD: 'Create a board',
        PROJECTS_BOARD_NEW_DIALOG_GENERAL: 'General',
        PROJECTS_BOARD_NEW_DIALOG_MEMBERS: 'Members',
    }
};
